<template>
  <div class="app-main-content">
    <!-- 需要在切换回来后，页面保持不变，所以使用v-show -->
    <booking-tree-grid
      v-show="view==='list'"
      ref="bookingTreeGrid"
      :is-fba="isFba"
      :context="context"
      :is-query="isQuery"
      @look="lookHandle"
      @add="addHandle"
      @edit="editHandle"
      @split="splitHandle"
      @copy="copyHandle"
    />
    <booking-workspace
      v-show="view==='detail'"
      ref="bookingWorkspace"
      :is-fba="isFba"
      :parent-context="context"
      :view="view"
      @copy="copyHandle"
      @back="backToList"
      @add="addHandle"
    />
    <!--业务复制选择复制哪些信息-->
    <job-copy-window
      :visible.sync="copyDialog.visible"
      :lob="copyDialog.job.lob || ''"
      @confirmCallBack="confirmCallBackHandler"
    />
    <job-no-rule-selector
      :visible.sync="jobNoRule.visible"
      :rules="jobNoRule.rules || []"
      @selectedBack="doCopyJob"
    />

    <!-- 业务类型选择 -->
    <el-dialog
      v-if="jobLobDialog.visible"
      v-el-drag-dialog
      :visible.sync="jobLobDialog.visible"
      :title="$t('CargoMsg.Cargo_BusinessType')"
      :width="$selectByLang('300px', '300px', '300px', '400px', '400px', '400px')"
      :close-on-click-modal="false"
      class="app-main-inner"
      @close="jobLobDialog.visible=false"
    >
      <div class="app-main-inner-row" style="flex-direction: column;padding-bottom: 10px;">
        <el-radio-group v-model="jobLobDialog.lob">
          <el-radio no="RE" label="RE">{{ $t('CargoMsg.Cargo_Export') }}</el-radio>
          <el-radio no="RI" label="RI" style="margin-left: -20px;">{{ $t('CargoMsg.Cargo_JobTypeImport') }}</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer">
        <el-button no="Confirm" type="primary" @click="confirmJobLovHandler">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
        <el-button no="Cancel" @click="() =>{this.jobLobDialog.visible=false}">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ReBookingContext } from './reBookingContext'
import bookingTreeGrid from './components/booking/bookingTreeGrid.vue'
import bookingWorkspace from './components/booking/bookingWorkspace'
import jobCopyWindow from '@/components/Cargo/Job/jobCopyWindow'
import jobNoRuleSelector from '@/components/Cargo/Job/jobNoRuleSelector'
import { ErrorTip } from '@/utils/class/ErrorTip'
import LocalStorageUtils from '@/utils/localStorageUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { queryJobNoRule, doCopyJob, advancedQuery } from '@/api/railwayExport/reBooking'
import { getLoading } from '@/utils/utilBaseElement'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { JumpUtil } from '@/utils/JumpUtil'

export default {
  name: 'ReBooking',
  components: { bookingTreeGrid, bookingWorkspace, jobCopyWindow, jobNoRuleSelector },
  data() {
    return {
      loading: null,
      context: new ReBookingContext(),
      view: 'list',
      copyDialog: {
        visible: false,
        job: {}
      },
      jobNoRule: {
        visible: false,
        rules: ''
      },
      jobLobDialog: { // 业务类型选择弹窗
        visible: false,
        lob: 'RE',
        row: null
      },
      isFba: false, // 是否FBA,
      isQuery: false // 根据路由参数进行高级查询
    }
  },
  created() {
    // 判断是否FBA
    const index = this.$route.path.lastIndexOf('/')
    const str = this.$route.path.substr(index + 1)
    this.isFba = str ? str.startsWith('FBA') : false
  },
  activated() {
    const params = this.$route.params
    if (params.conditions) {
      this.isQuery = true
      this.view = 'list'
      this.$refs.bookingTreeGrid.isAdvancedQuery = true
      this.$refs.bookingTreeGrid.toAdvancedQuery(params.conditions)
      delete params.conditions
    } else if (this.$route.params.jobNos) {
      const filter = {
        fba: this.isFba
      }
      JumpUtil.jumpToTab(advancedQuery, filter, this.$route.params, this)
    } else if (this.$route.query.jobNo) {
      this.toDetail(this, this.$route.query.jobNo, this.$route.params.branchId)
      location.replace(location.href.replace(location.hash, `#${this.$route.path}`))
    } else if (this.$route.params.code) {
      if (this.$route.meta.showExtraParam) {
        this.view = 'list'
        this.$route.meta.showExtraParam = false
      }
      this.isQuery = true
      this.sopNodeAdvancedQuery()
    } else if (this.$route.params.jobNo) {
      this.$refs.bookingWorkspace.activeTabName = this.$route.params.activeTabName || ''
      this.toDetail(this, this.$route.params.jobNo, this.$route.params.branchId)
      location.replace(location.href.replace(location.hash, `#${this.$route.path}`))
      delete this.$route.params.jobNo
      delete this.$route.params.activeTabName
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  methods: {
    // 首页sop面板高级查询
    sopNodeAdvancedQuery() {
      const { code, subCode, name, subName, newSubNodes, etdStart, lob, templateKey } = this.$route.params
      let jobState = this.$route.params.jobState
      jobState = jobState.split(',').map(item => { return Number(item) })
      const data = [
        {
          fieldName: 'trackingInfo._multipleState_',
          fieldType: 'trackingMultiple',
          operator: '=',
          value: {
            operator: 'and',
            value: [
              {
                code,
                name,
                details: []
              }
            ]
          }
        },
        {
          fieldName: 'job.ETD',
          fieldType: 'FIELD_DATE_RANGE',
          operator: 'RANGE',
          value: `type=date,start=${etdStart}`
        },
        {
          fieldName: 'job.JOB_STATE',
          fieldType: null,
          label: '',
          operator: 'IN',
          value: jobState
        },
        {
          fieldName: 'job.lob',
          fieldType: null,
          label: '',
          operator: '=',
          value: lob
        }
      ]
      if (subCode && subName) {
        data[0].value.value[0]['details'].push({ code: subCode, name: subName })
      } else {
        data[0].value.value[0]['details'] = newSubNodes
      }
      // Sop模板UUID
      if (templateKey) {
        data.push(
          {
            fieldName: 'job.TRACKING_TEMPLATE_UUID',
            fieldType: null,
            label: '',
            operator: '=',
            value: templateKey
          }
        )
      }
      this.$refs.bookingTreeGrid.isAdvancedQuery = true
      this.$refs.bookingTreeGrid.toAdvancedQuery(data)
    },
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    async addHandle(row) {
      await this.context.prepareData()
      if (!this.context.office) {
        this.$message.info(this.$t('Message.CurrentBranchIsNotSelectedCannotAddNewBookings'))
        return
      }
      if (JobUtils.checkHQ()) { return }
      // 铁路头程默认铁出
      if (this.isFba) {
        row.lob = 'RE'
        row.fba = true
        this.detailHandle('add', row)
        return
      }
      this.jobLobDialog.lob = 'RE'
      this.jobLobDialog.row = row
      this.jobLobDialog.visible = true
    },
    async editHandle(row) {
      if (row.jobState !== 0) {
        this.$message.info(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
        return
      }
      if (!await SecurityUtil.canEdit(new RailwayExportJob(row))) {
        this.$message.info(this.$t('Message.NoPermissionToEditTheJob'))
        return
      }
      this.detailHandle('edit', row)
    },
    splitHandle(row) {
      this.detailHandle('split', row)
    },
    copyHandle(row) {
      // 以后按本次选择复制，不弹出此框
      if (!row) return
      if (JobUtils.checkHQ()) { return }
      this.copyDialog.job = row
      const isShowView = LocalStorageUtils.getConfiguration('COPY_JOB_' + row.lob) // 是否显示复制选项弹框【勾选是true不显示】
      this.$logger.log('是否显示复制选项弹框', typeof isShowView + isShowView)
      if (isShowView !== true) {
        this.copyDialog.visible = true
      } else {
        this.confirmCallBackHandler()
      }
    },
    async confirmCallBackHandler() {
      await this.context.prepareData()
      if (String(this.context.config.get('UseNewJobNoRule')) === '1') {
        this.loading = getLoading()
        queryJobNoRule(SystemConstants.RE.code).then(res => {
          this.loading.close()
          this.ruleResultHandler(res)
        })
      } else {
        this.doCopyJob()
      }
    },
    ruleResultHandler(event) {
      const rules = event.data
      if (rules && rules.length > 1) {
        this.jobNoRule.visible = true
        this.jobNoRule.rules = rules
      } else if (rules && rules.length > 0) {
        const rule = rules[0]
        this.doCopyJob(rule)
      } else {
        this.$message.warning(this.$t('SeaExport.MaintainJobNoRule'))
        return
      }
    },
    doCopyJob(jobNoRule) {
      const item = {}
      item.jobRule = !jobNoRule ? '' : jobNoRule.uuid
      item.jobUuid = this.copyDialog.job.uuid
      item.branchId = this.$store.getters.currentOfficeId
      // 复制哪些页签的数据
      const lob = this.copyDialog.job.lob
      item.vesselEq = LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob)
      item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob)
      item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob)
      item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
      item.prePlanBooking = LocalStorageUtils.getConfiguration('COPY_PRE_PLAN_BOOKING_' + lob)
      item.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUT' + lob)
      const notMatchAgainSelect = LocalStorageUtilsNew.getConfiguration('NOT_MATCH_AGAIN_SELECT_' + lob)
      item.all = false
      this.$logger.log('复制-item-条件', item)
      this.loading = getLoading()
      doCopyJob(item).then(async res => {
        this.loading.close()
        const newJob = res.data
        newJob.opOffice = this.$store.getters.currentOfficeId || newJob.opOffice
        newJob.planner = 0
        newJob.soNo = ''
        newJob.bookingNo = ''
        newJob.returnPeriodBegin = ''
        newJob.returnPeriodEnd = ''
        newJob.fileCutoff = ''
        const continueExec = await JobUtils.validateJobFieldActive(newJob, this, 'ReBooking')
        if (!continueExec) {
          return
        }
        await JobUtils.doNotMatchAgainSelect(newJob, notMatchAgainSelect, { delay: !newJob.masterFlag })
        this.$logger.log('复制-new job', newJob)
        this.detailHandle('copy', newJob)
      })
    },
    // 查询job后跳转详情
    toDetail(vm, jobNo, branchId) {
      const filter = {}
      filter.conditions = [
        new AdvancedSearchOption(null, 'job.JOB_NO', jobNo, 'LIKE').formatObj2Json()
      ]
      filter.branchId = branchId || this.$store.getters.currentOfficeId
      filter.pageNum = 1
      filter.pageSize = this.pageSize
      vm.view = 'detail'
      advancedQuery(filter).then(res => {
        const rowData = res.data.list
        if (rowData && rowData.length > 0) {
          vm.$refs.bookingWorkspace.saveJobNos = []
          vm.$refs.bookingWorkspace.removedJobNos = []
          const index = rowData.findIndex(p => p.jobNo === jobNo)
          if (index > 0) {
            vm.$refs.bookingWorkspace.onShow('look', rowData, rowData[index])
          } else {
            vm.$refs.bookingWorkspace.onShow('look', rowData, rowData[0])
          }
        } else {
          vm.$message.error(vm.$t('Message.NoRecordMeetTheConditions'))
          vm.$refs.bookingWorkspace.goBack()
        }
      }).catch(() => {
        vm.$message.error(this.$t('Message.JumpFailed'))
      })
    },
    // 进详情处理
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.bookingWorkspace.rowData
      } else {
        this.view = 'detail'
        rowData = this.$refs.bookingTreeGrid.rowData
      }
      this.$refs.bookingWorkspace.saveJobNos = []
      this.$refs.bookingWorkspace.removedJobNos = []
      this.$refs.bookingWorkspace.onShow(type, rowData, row)
    },
    backToList(saveJobNos, removedJobNos) {
      this.view = 'list'
      if (this.$route.query.jobNo) {
        delete this.$route.query.jobNo
        delete this.$route.query.currentOfficeId
      }
      if (saveJobNos && saveJobNos.length > 0 || removedJobNos && removedJobNos.length > 0) {
        this.$refs.bookingTreeGrid.toQuery(saveJobNos, removedJobNos)
      }
    },
    // 确认选择业务类型
    confirmJobLovHandler() {
      this.jobLobDialog.visible = false
      this.jobLobDialog.row.lob = this.jobLobDialog.lob
      this.detailHandle('add', this.jobLobDialog.row)
    }
  }
}
</script>
